<template>
  <div :class="'column is-4'">
    <div class="app-block p-md">
      <form @submit.prevent="send">
        <div class="has-text-centered">
          <div v-if="candidatePhoto()"
               class="profile-image p-l-xl p-r-xl">
            <transition name="component-fade" mode="out-in">
              <img :src="profile_photo" :key="profile_photo" class="img-responsive">
            </transition>
            <div class="m-t-md">
              <div class="file is-boxed is-pulled-right">
                <label class="file-label">
                  <input class="file-input" type="file" name="resume" @change="onFileChange">
                  <span class="button">Modifier</span>
                </label>
              </div>
              <br>
              <transition name="slide-fade">
                <div class="has-text-danger has-text-centered">{{ errorImg }}</div>
              </transition>
            </div>
          </div>
          <picture-input v-else
                         ref="pictureInput"
                         @change="onChange"
                         :width="250"
                         :height="300"
                         margin="16"
                         accept="image/jpeg,image/png"
                         size="2"
                         buttonClass="button"
                         :customStrings="pictureStrings">
          </picture-input>
        </div>
        <div>


          <div class="legend heading-line">
            <span :class="'school-title-'+schoolSlug">1 - {{ $t('candidate.contact.title') }}</span>
          </div>

          <div class="columns">
            <div class="column">
              <label class="label"
                     v-bind:class="[ errors.has('gender') ? 'has-text-danger' : '']">{{
                  $t('candidate.contact.sex.label')
                }}</label>
              <div class="radio-group">
                <label>
                  <input type="radio" name="gender" v-validate="'required|in:M,F'"
                         :value="'M'"
                         v-model="candidate.gender">
                  <div class="choice">
                    <span>{{ $t('candidate.contact.sex.male') }}</span>
                  </div>
                </label>
                <label>
                  <input type="radio" name="gender" :value="'F'"
                         v-model="candidate.gender">
                  <div class="choice">
                    <span>{{ $t('candidate.contact.sex.female') }}</span>
                  </div>
                </label>
              </div>
            </div>
          </div>


          <div class="columns">
            <div class="column">
              <label class="label"
                     v-bind:class="[ errors.has('first_name') ? 'has-text-danger' : '']">{{
                  $t('candidate.contact.first_name')
                }}</label>
              <input class="input"
                     v-validate="'required'"
                     type="text"
                     :disabled="accepted"
                     name="first_name"
                     v-model="candidate.first_name">
            </div>
            <div class="column">
              <label class="label" :class="[ errors.has('last_name') ? 'has-text-danger' : '']">{{
                  $t('candidate.contact.last_name')
                }}</label>
              <input class="input" v-validate="'required'" type="text" name="last_name"
                     :disabled="accepted"
                     v-model="candidate.last_name">
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <label class="label"
                     :class="[ errors.has('email') ? 'has-text-danger' : '']">{{
                  $t('candidate.contact.email')
                }}</label>
              <input class="input" type="text"
                     name="email"
                     v-model="candidate.email">
            </div>
          </div>

          <hr>

          <div class="columns">
            <div class="column">
              <label class="label" :class="[ errors.has('address') ? 'has-text-danger' : '']">{{
                  $t('candidate.contact.address')
                }}</label>
              <input class="input m-b-md"
                     v-validate="'required'"
                     type="text"
                     name="address"
                     v-model="candidate.address">

              <input class="input" type="text"
                     :placeholder="$t('candidate.contact.address_complement')"
                     v-model="candidate.address_complement">
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <label class="label" :class="[ errors.has('post_code') ? 'has-text-danger' : '']">{{
                  $t('candidate.contact.post_code')
                }}</label>
              <input class="input"
                     v-validate="'required'"
                     type="text"
                     name="post_code"
                     v-model="candidate.post_code">
            </div>
            <div class="column">
              <label class="label"
                     :class="[ errors.has('city') ? 'has-text-danger' : '']">{{ $t('candidate.contact.city') }}</label>
              <input class="input"
                     v-validate="'required'"
                     type="text"
                     name="city"
                     v-model="candidate.city">
            </div>
          </div>
          <div class="columns">
            <div class="column is-12">
              <label class="label"
                     :class="[ errors.has('country') ? 'has-text-danger' : '']">{{
                  $t('candidate.contact.country')
                }}</label>

              <div class="select">
                <select name="country" v-model="candidate.country">
                  <option value="">---</option>


                  <option
                      v-for="country in countries"
                      :value="country['alpha-2']"
                  >
                    {{ country.country }}
                  </option>

                </select>
              </div>
            </div>
          </div>


          <div class="columns">
            <div class="column">
              <label class="label" v-bind:class="[ errors.has('phone') ? 'has-text-danger' : '']">
                {{ $t('candidate.contact.phone') }}</label>

              <VuePhoneNumberInput v-model="candidate.phone"
                                   :required="true"
                                   :border-radius="0"
                                   color="firebrick"
                                   :default-country-code="candidate.phone_code"
                                   :preferred-countries="['FR']"
                                   @update="updateCandidatePhone"
                                   :translations="{
                                    countrySelectorLabel: 'Code pays',
                                    countrySelectorError: 'Choisir un pays',
                                    phoneNumberLabel: 'Numéro de téléphone',
                                    example: 'Exemple :'
                                  }"
              />
            </div>
          </div>

          <hr>

          <div class="columns">
            <div class="column">

              <label class="label" :class="[ errors.has('birthday') ? 'has-text-danger' : '']">
                {{ $t('candidate.contact.birthday') }}
              </label>

              <b-input type="text"
                       placeholder="JJ/MM/AAAA"
                       v-validate="'required'" name="birthday"
                       :disabled="accepted"
                       v-cleave="masks.date"
                       v-model="date"></b-input>
            </div>
            <div class="column">
              <label class="label"
                     :class="[ errors.has('birthplace') ? 'has-text-danger' : '']">
                {{ $t('candidate.contact.birth_place') }}
              </label>
              <input class="input"
                     type="text"
                     name="birthplace"
                     v-model="candidate.birth_place">
            </div>
          </div>


          <div class="columns">
            <div class="column is-6">

              <label class="label">
                {{ $t('candidate.contact.nationality') }}
              </label>

              <div class="select">
                <select name="pays" v-model="candidate.nationality">
                  <option value="">---</option>


                  <option
                      v-for="country in countries"
                      :value="country['alpha-2']"
                  >
                    {{ country.nationality }}
                  </option>

                </select>
              </div>
            </div>
          </div>

        </div>

        <hr>

        <social-links-form
            :candidate-social-links="socialLinks"
            @update:socialLinks="updateSocialLinks"
        />
        <hr>


        <div class="has-text-centered m-t-md">
          <button :class="'button-valid button ' + isLoading">
            {{ $t('labels.general.save') }}
          </button>
          <br>
          <br>
          <transition name="slide-fade">
            <div class="has-text-danger has-text-centered">{{ errorMsg }}</div>
          </transition>
        </div>
      </form>
      <br>


    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import PictureInput from '../../../components/elements/PictureInput'
import moment from 'moment'
import Cleave from 'cleave.js'
import CountriesFR from '../../../utils/countries_fr.json'
import CountriesEU from '../../../utils/euro-countries.json'
import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'
import SocialLinksForm from "../../../components/application/SocialLinksForm.vue";

const cleave = {
  name: 'cleave',
  bind(el, binding) {
    const input = el.querySelector('input')
    input._vCleave = new Cleave(input, binding.value)
  },
  update(el, binding) {
    const input = el.querySelector('input')
    input._vCleave.destroy()
    input._vCleave = new Cleave(input, binding.value)
  },
  unbind(el) {
    const input = el.querySelector('input')
    input._vCleave.destroy()
  }
}

export default {
  directives: {cleave},
  components: {
    SocialLinksForm,
    VuePhoneNumberInput,
    PictureInput
  },
  data() {
    return {
      isLoading: '',
      date: null,
      passport_validity: null,
      profile_photo: '',
      masks: {
        date: {
          date: true,
          datePattern: ['d', 'm', 'Y']
        }
      },
      countries: null,
      countriesEU: null,
      pictureStrings: {
        upload: this.$t('candidate.contact.image.validation.browser'),
        drag: this.$t('candidate.contact.image.placeholder_boarding'),
        tap: this.$t('candidate.contact.image.tap'),
        change: this.$t('candidate.contact.image.change'),
        remove: this.$t('candidate.contact.image.remove'),
        select: this.$t('candidate.contact.image.select'),
        selected: this.$t('candidate.contact.image.selected'),
        fileSize: this.$t('candidate.contact.image.validation.size'),
        fileType: this.$t('candidate.contact.image.validation.type')
      },
      errorMsg: '',
      errorImg: '',
      activeTab: 0,
      socialLinks: []
    }
  },

  props: {
    school: {type: Object},
    schoolSlug: {type: String},
    candidate: {type: Object}
  },
  computed: {
    ...mapGetters({
      status: 'candidate/getStatus',
      candidateAccount: 'candidate/getCandidateAccount',
      account: 'auth/getAccount',
      isLoggedIn: 'auth/isLoggedIn'
    }),
    application() {
      return this.candidate.applications
    },
    accepted() {
      return this.application && this.application.accepted === 1
    },
    registered() {
      return this.application.registration && this.application.registration.registered_candidate
    },
  },
  methods: {
    ...mapActions('candidate', [
      'addCandidate'
    ]),
    ...mapActions({
      updateCandidate: 'candidate/updateContact'
    }),
    toggleLoading: function () {
      this.isLoading = (this.isLoading === '') ? 'is-loading' : ''
    },
    candidatePhoto() {
      if (this.candidate.profile_photo) {
        return this.candidate.profile_photo.length > 0
      }
      return false
    },
    updateCandidatePhone(phone) {
      if (this.candidate.phone && !phone.isValid) {
        this.errorMsg = "Attention votre numéro de téléphone ne semble pas valide"
      } else {
        this.errorMsg = null
      }
      this.candidate.phone_code = phone.countryCode
    },
    updateSocialLinks(links) {
      this.socialLinks = links;
    },
    send: function () {

      this.$validator.validateAll().then((result) => {


        if (result || this.registered) {


          this.toggleLoading()

          this.candidate.profile_photo = this.profile_photo
          this.candidate.social_links = this.socialLinks
          this.candidate.school_type = 3

          if (!this.candidate.user) {
            this.candidate.user = this.account
          }


          if (this.date && moment(this.date, 'DD/MM/YYYY').isValid()) {
            this.candidate.birthday = moment(this.date, 'DD/MM/YYYY').format('YYYY-MM-DD');
          }

          if (this.isLoggedIn) {

            if (this.candidate.newCandidate) {
              this.addCandidate(this.candidate).then((result) => {
                switch (this.status) {
                  case 200:
                    this.toggleLoading()
                    this.$emit('send')
                    break
                  case 403:
                    this.toggleLoading()
                    this.$emit('notAuthenticated')
                    break
                  case 422:
                    this.toggleLoading()
                    this.errorMsg = this.$t('candidate.contact.validation.email')
                    break
                  default:
                    this.toggleLoading()
                    this.errorMsg = this.$t('candidate.general.unknown')
                }
              }).catch((err) => {
                this.toggleLoading()
                this.error = err.message
              })
            } else {
              this.updateCandidate(this.candidate).then((result) => {

                switch (this.status) {
                  case 200:
                    this.toggleLoading()
                    this.$emit('send')
                    break
                  case 403:
                    this.toggleLoading()
                    this.$emit('notAuthenticated')
                    break
                  case 422:
                    this.toggleLoading()
                    this.errorMsg = this.$t('candidate.contact.validation.email')
                    break
                  default:
                    this.toggleLoading()
                    this.errorMsg = this.$t('candidate.general.unknown')
                }
              }).catch((err) => {
                this.toggleLoading()
                this.error = err.message
              })
            }

          }

        } else {
          this.errorMsg = this.$t('candidate.contact.validation.empty_field')
          setTimeout(() => {
            this.errorMsg = ''
          }, 1500)
        }
      })
    },
    onFileChange(e) {
      this.errorImg = ''
      const files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      if (files[0].size > 2000000) {
        this.errorImg = this.$t('candidate.contact.image.validation.size')
        return
      }

      this.createImage(files[0])
    },
    createImage(file) {
      const reader = new FileReader()
      const vm = this
      reader.onload = (e) => {
        vm.profile_photo = e.target.result
      }
      reader.readAsDataURL(file)
    },
    onChange() {
      if (this.$refs.pictureInput.image) {
        this.profile_photo = this.$refs.pictureInput.image
      }
    },
  },
  created() {
    if (this.candidateAccount && this.candidateAccount.social_links) {
      this.socialLinks = [...this.candidateAccount.social_links];
    } else if (this.candidate && this.candidate.social_links) {
      this.socialLinks = [...this.candidate.social_links];
    }
    if (this.candidate.birthday) {
      this.date = moment(new Date(this.candidate.birthday)).format('DD/MM/YYYY');
    }
    if (this.candidate.profile_photo) {
      this.profile_photo = '/profiles/' + this.candidate.profile_photo
    }
    this.countries = CountriesFR
    this.countriesEU = CountriesEU
  }
}
</script>
<style scoped>
.b-radio.radio .control-label {
  padding-left: 0.2em;
  float: left;
}
</style>
